import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';

import { ReactComponent as ArrowBackIcon } from '../../icons/arrow-left-circle-solid.svg';

import './LoadMoreFooter.scss';

const LoadMoreFooter = ({ remainingSongs, displayedCount, onLoadMore, onScrollToTop }) => {
  const { t } = useTranslation();

  if (displayedCount === 0) return null;

  return (
    <div className="LoadMoreFooter">
      {remainingSongs > 0 ? (
        <>
          <button className="load-more-btn" onClick={onLoadMore}>
            {t('songs.showMore', { count: remainingSongs })}
          </button>
          <button className="load-more-btn" onClick={onScrollToTop} title={t('common.backToTop')}>
            <Icon icon={<ArrowBackIcon />} className="back-to-top-icon solid" />
          </button>
        </>
      ) : (
        <>
          <button className="load-more-btn" disabled>
            {t('songs.showingAll', { count: displayedCount })}
          </button>
          <button className="load-more-btn" onClick={onScrollToTop} title={t('common.backToTop')}>
            <Icon icon={<ArrowBackIcon />} className="back-to-top-icon solid" />
          </button>
        </>
      )}
    </div>
  );
};

LoadMoreFooter.propTypes = {
  remainingSongs: PropTypes.number.isRequired,
  displayedCount: PropTypes.number.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  onScrollToTop: PropTypes.func.isRequired,
};

export default LoadMoreFooter;
